import React from "react";
import {useSelector} from "react-redux";
import t from "../../components/I18N/TranslateHelpers";
import {SearchModeProp} from "./SearchResultsPage";
import SearchResultsListItem from "./SearchResultsListItem";
import {SpinnerOnTop} from "../../components/SpinnerOnTop";
import {RootState} from "../../app/RootReducer";
import {SearchResult} from "../Entity/SearchResult";

const getSearchResults = (searchResults: SearchResult[]) => {
  return searchResults;
};

function SearchResultsList(componentProps: SearchModeProp) : JSX.Element {
  const searchResults = useSelector((state: RootState) => getSearchResults(state.searchRdc.searchResults));
  const isLoading = useSelector((state: RootState) => state.searchRdc.isLoading);


  const nbOfProducts = searchResults.filter((a) => a.type === "product").length
  const nbOfDrupal = searchResults.filter((a) => a.type === "drupal-content").length


  return (
    <>
      {
        isLoading ?
          <div className="container py-5 d-flex align-items-center justify-content-center">
            <SpinnerOnTop/>
          </div>
          :
          <>
            <section className="row">
              {searchResults && searchResults.length > 0 ?
                <>
                  <div className="bg-circle-bottom">
                    <div className="container my-5">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="card">
                            <div className="card-body text-center">
                              <label className="text-black pr-1">
                                <i className="fa fa-search mr-5 text-primary"></i>
                                {
                                  searchResults.length > 1 ?
                                    t("found_results", {nbResult: searchResults.length})
                                    :
                                    t("found_result", {nbResult: searchResults.length})
                                }
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="card">
                            <div className="card-body text-center">
                              <label className="text-black pr-1">
                                <i className="fa fa-shopping-cart mr-5 text-primary"></i>
                                <strong>{nbOfProducts} </strong>
                                <span>{nbOfProducts > 1 ? t('products_found') : t('product_found')}</span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="card">
                            <div className="card-body text-center">
                              <label className="text-black pr-1">
                                <i className="fal fa-browser mr-5 text-primary"></i>
                                <strong>{nbOfDrupal} </strong>
                                <span>{nbOfDrupal > 1 ? t('contents_found_on_website') : t('content_found_on_website')}</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border-top border-bottom section-cta pt-3 pb-3">
                      <div className="container">
                        <div className="row pt-3">
                          {searchResults.filter((a) => a.type === "product").map((searchResult: SearchResult, index: number) => (
                            <SearchResultsListItem key={searchResult.id ?? ''} searchResult={searchResult} isDrupalContent={false}/>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="site-web-search pt-5">
                    <div className="container">
                      <div className="row">
                        {searchResults.filter((a) => a.type === "drupal-content").map((searchResult: SearchResult, index: number) => (
                          <SearchResultsListItem key={searchResult.id ?? ''} searchResult={searchResult} isDrupalContent={true}/>
                        ))}
                      </div>
                    </div>
                  </div>
                </>
                :
                <div className="container-no-result py-5">
                  <div className="container">
                    <div className="row">
                      <div className="alert alert-warning mb-0">
                        {t('no_result')}
                      </div>
                    </div>
                  </div>
                </div>
              }
            </section>
          </>
      }
    </>
  )
}
export default SearchResultsList;
